import {ShieldLockIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Flash} from '@primer/styled-react'
import type {CopilotAgentError} from '@github-ui/copilot-chat/utils/copilot-chat-types'

import styles from './SingleSignOnBanner.module.css'

export function SSOBannerFromError({error, className}: {error: CopilotAgentError; className?: string}) {
  // identifier comes from X-GitHub-SSO header e.g.
  // "required; url=http://github.localhost/orgs/fabrikam/sso?authorization_request=ABC"
  const identifier = error.identifier || ''
  const authorizeUrl = identifier.split('url=')[1] || ''
  const orgMatch = identifier.match(/\/([^/]+)\/sso/)
  const org = (orgMatch && orgMatch[1]) || ''

  if (!org || !authorizeUrl) {
    return null
  }

  return (
    <div className={className} data-testid="sso-banner">
      <div className={styles.Box}>
        <section aria-label="Single sign-on information">
          <Flash sx={{borderRadius: 2, borderWidth: 1}} className={styles.Flash}>
            <div>
              <ShieldLockIcon />
              <Link inline href={buildAuthorizeUrl({authorizeUrl})}>
                Single sign-on
              </Link>{' '}
              to see results in the <b>{org}</b> organization.
            </div>
          </Flash>
        </section>
      </div>
    </div>
  )
}

function buildAuthorizeUrl({authorizeUrl}: {authorizeUrl: string}): string {
  const url = new URL(authorizeUrl, window.location.origin)
  url.searchParams.set('return_to', window.location.toString())

  return url.toString()
}

try{ SSOBannerFromError.displayName ||= 'SSOBannerFromError' } catch {}